export default __webpack_public_path__ + "static/media/cardIcon3.9d7a15b0.svg";